<template>
  <div class="contact">
    <!-- 页面标题 -->
    <section class="page-title">
      <div class="container">
        <h1>联系我们</h1>
        <p>期待与您的合作</p>
      </div>
    </section>

    <!-- 联系信息 -->
    <section class="contact-info">
      <div class="container">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8">
            <div class="info-card">
              <i class="el-icon-location"></i>
              <h3>公司地址</h3>
              <p>深圳南山区深南大道10128号南山数字文化产业基地西塔1103</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <div class="info-card">
              <i class="el-icon-phone"></i>
              <h3>联系电话</h3>
              <p>400-188-0608</p>
              <p>0755-83224006</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <div class="info-card">
              <i class="el-icon-message"></i>
              <h3>电子邮箱</h3>
              <p>611699108@qq.com</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 联系表单 -->
    <section class="contact-form">
      <div class="container">
        <h2>在线留言</h2>
        <el-form :model="form" :rules="rules" ref="form" label-width="80px">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="电话" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="form.companyName" placeholder="请输入您的公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="公司地址" prop="address">
                <el-input v-model="form.address" placeholder="请输入您的公司地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入您的电子邮箱"></el-input>
          </el-form-item>
          <el-form-item label="应用设备" prop="subject">
            <el-input v-model="form.subject" placeholder="请输入您的应用设备"></el-input>
          </el-form-item>
          <el-form-item label="采购需求" prop="message">
            <el-input type="textarea" v-model="form.message" :rows="4" placeholder="请输入您的采购需求"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交留言</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>

    <!-- 地图 -->
    <section class="map-section">
      <div class="container">
        <h2>公司位置</h2>
        <div class="map-container">
          <!-- 这里可以集成地图组件，如百度地图或高德地图 -->
          <div class="map-placeholder">
            <div id="baiduMap" style="width: 100%; height: 100%;"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入公司地址', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        subject: [
          { required: true, message: '请输入应用设备', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入采购需求', trigger: 'blur' },
          { min: 10, max: 500, message: '长度在 10 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.initBaiduMap();
  },
  methods: {
    initBaiduMap() {
      // 创建地图实例，这里的 'baiduMap' 对应上面 div 的 id
      const map = new BMap.Map("baiduMap");; 
      // 创建点坐标，这里使用示例坐标，你可以替换为实际公司坐标
      const point = new BMap.Point(113.935259,22.54652); 
      // 初始化地图，设置中心点和缩放级别
      map.centerAndZoom(point, 15); 
      // 添加地图控件 
      var marker = new BMap.Marker(point);
      map.addOverlay(marker);  
      marker.disableDragging(); 
      const opts = {
        width : 200,     // 信息窗口宽度
        height: 100,     // 信息窗口高度
        title : "深圳市桔子智联信息技术有限公司" , // 信息窗口标题
        enableMessage:true,//设置允许信息窗发送短息
        message:"深圳市南山区南头街道莲城社区深南大道10128号南山软件园B1103"
      }
      const infoWindow = new BMap.InfoWindow("地址：深圳市南山区南头街道莲城社区深南大道10128号南山软件园B1103", opts);  // 创建信息窗口对象 
      map.openInfoWindow(infoWindow,point); //开启信息窗口
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 这里添加表单提交逻辑
          this.$message.success('留言提交成功！');
          this.resetForm();
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    }
  }
}
</script>

<style lang="scss" scoped>
.contact {
  .page-title {
    background: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('~@/assets/images/contact-bg.jpg');
    background-size: cover;
    background-position: center;
    color: #fff;
    padding: 100px 0;
    text-align: center;
    
    h1 {
      font-size: 48px;
      margin-bottom: 20px;
    }
    
    p {
      font-size: 20px;
      opacity: 0.9;
    }
  }
  
  .contact-info {
    padding: 40px 0;
    background: #f8f9fa;
    
    .info-card {
      height: 200px;
      text-align: center;
      padding: 30px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 20px;
      
      i {
        font-size: 48px;
        color: #409EFF;
        margin-bottom: 20px;
      }
      
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #2c3e50;
      }
      
      p {
        color: #666;
        margin-bottom: 10px;
        line-height: 1.6;
      }
    }
  }
  
  .contact-form {
    padding: 40px 0;
    
    h2 {
      text-align: center;
      font-size: 36px;
      margin-bottom: 40px;
      color: #2c3e50;
    }
    
    .el-form {
      max-width: 800px;
      margin: 0 auto;
    }
  }
  
  .map-section {
    padding: 80px 0;
    background: #f8f9fa;
    
    h2 {
      text-align: center;
      font-size: 36px;
      margin-bottom: 40px;
      color: #2c3e50;
    }
    
    .map-container {
      height: 400px;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      
      .map-placeholder {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #eee;
        color: #666;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .contact {
    .page-title {
      padding: 60px 0;
      
      h1 {
        font-size: 32px;
      }
      
      p {
        font-size: 16px;
      }
    }
    
    .contact-info, .contact-form, .map-section {
      padding: 40px 0;
    }
    
    .contact-form h2, .map-section h2 {
      font-size: 28px;
      margin-bottom: 30px;
    }
    
    .map-container {
      height: 300px;
    }
  }
}
</style> 